import { connect } from 'react-redux';

import SignupComponent from './signup.component';

import * as models from '@app/models/index';
import { Dispatch } from 'redux';

import * as actions from '@app/actions/index';

function mapStateToProps(authState: models.IAuthState): models.IAuthState {
	return {
		...authState,
	};
}

function mapDispatchToProps(dispatch: Dispatch<actions.AuthActions>): models.ISignUpComponentProps {
	return {
		intl: null,
		openSnackBar: null,
		onUserSignUp: (state) => dispatch(actions.userSignedUpAction(state)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SignupComponent);



// WEBPACK FOOTER //
// ./src/components/account/signup/signup.ts